import React from "react";
import LegalPage, { H2, P } from "./LegalPage";

export default function Delivery() {
  return (
    <LegalPage title="Shipping & Delivery Policy">

      <H2>1. Service Area</H2>
      <P>
        Grox24 currently operates in Erode and surrounding areas. Expansion may
        change service availability.
      </P>

      <H2>2. Delivery Time</H2>
      <P>
        Delivery times shown in the app are estimates and may vary depending on
        demand, weather, and operational conditions.
      </P>

      <H2>3. Failed Delivery</H2>
      <P>
        If delivery fails due to customer unavailability, Grox24 may reschedule
        or cancel the order.
      </P>

      <H2>4. Minimum Order Value</H2>
      <P>
        Minimum order values and delivery charges may apply as specified in the
        app.
      </P>

    </LegalPage>
  );
}